import { Clickable } from '@carvana/merch-components';
import { useContext, useEffect, RefObject, useRef } from 'react';
import GlobalContext from '~/context/giveaway/GlobalContext';
import ModalContext from '~/context/giveaway/ModalContext';
import useShareLink from '~/hooks/common/useShareLink';
import { BannerContainer, ShareButton } from './StickyBanner.styles';
import { shareData } from '../constants';
import { LightCtaButton } from '../CtaButton';
import { ShareContainer } from '../Spinner/SpinnerSection.styles';

export default function StickyBanner({
  heroRef
}: {
  heroRef: RefObject<HTMLElement>;
}) {
  const { giveawayIsLive } = useContext(GlobalContext);
  const { setGiveawayModalOpen } = useContext(ModalContext);
  const stickyBannerRef = useRef<HTMLElement>(null);
  const shareLink = useShareLink(shareData);

  useEffect(() => {
    const handleScroll = () => {
      if (
        !heroRef ||
        !heroRef.current ||
        !stickyBannerRef ||
        !stickyBannerRef.current
      )
        return;

      const { top: stickyBoundTop } = heroRef.current.getBoundingClientRect();

      if (stickyBoundTop >= 0) {
        stickyBannerRef.current.classList.add('-translate-y-full');
        stickyBannerRef.current.classList.remove('translate-y-0');
      }

      if (stickyBoundTop <= 0) {
        stickyBannerRef.current.classList.add('translate-y-0');
        stickyBannerRef.current.classList.remove('-translate-y-full');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [heroRef]);

  return (
    <BannerContainer ref={stickyBannerRef}>
      <div className="flex items-center">
        <div className="mr-12 h-32 w-32 rounded-full m:h-[42px] m:w-[42px] l:mr-16">
          <picture>
            <source
              srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/header/Air_Jaxson.png?width=42`}
              media="(min-width: 768px)"
            />
            <img
              src={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/header/Air_Jaxson.png?width=32`}
              alt="air-jaxson"
            />
          </picture>
        </div>
        <span className="bold text-white s:tl-header-s m:text-2xl l:tl-header-xl">
          Styled & Dialed Giveaway
        </span>
      </div>
      <div className="hidden flex-row items-center m:flex">
        <Clickable
          element={ShareContainer}
          onClick={shareLink}
          data-analytics-id="header-giveaway-share"
          data-qa="header-giveaway-share"
          title="Share"
        >
          <ShareButton className="mr-24" />
        </Clickable>
        <LightCtaButton
          className="!mx-0 h-56 w-[200px] m:h-48 m:w-[196px] l:h-56 l:w-[250px]"
          disabled={!giveawayIsLive}
          type="button"
          onClick={() => {
            setGiveawayModalOpen(true);
          }}
          data-analytics-id="Sticky - Styled & Dialed Giveaway - Enter Now"
        >
          {giveawayIsLive ? 'enter to win' : 'giveaway ended'}
        </LightCtaButton>
      </div>
    </BannerContainer>
  );
}
